import React, { useEffect } from 'react'
import Card from '../../../common/card/Card'
import { useState } from 'react'
import Button from '../../../common/button/Button'
import ResponseMessage from '../../../common/modal/ResponseMessage'
import { useParams } from 'react-router-dom'
import { QueryClient, useQuery } from '@tanstack/react-query'
import { performRequest } from '../../../common/utils'
import TeamSeats from './TeamSeats'
import AddTeamSeats from './AddTeamSeats'
import RestrictDomains from './RestrictDomains'
import { useGroupDashboardContext } from '../GroupDashboardContext'
import { addSeatVisibility } from './Utils'

const TeamSettings = ({
  teamData = [],
  teamOptionsData = {},
  refetchTeamData
}) => {

  const { filtersData } = useGroupDashboardContext()
  const [ teamName, setTeamName ] = useState( teamData.team_name ?? '' )
  const [ nameResponse, setNameResponse ] = useState('')
  const [ isDisable, setIsDisable ] = useState(false)
  const params = useParams()
  const teamId = params.team_id

  const queryClient = new QueryClient()
  const {
    isLoading,
    isFetching,
    refetch,
    data } = useQuery({
      queryKey: ['msync_update_team_name'],
      queryFn: updateTeamName,
      refetchOnWindowFocus: false,
      enabled: false
    }, queryClient)

  async function updateTeamName() {
    // const formData = new FormData()
    // formData.append('action', 'msync_update_team_name')
    // formData.append('team_id', teamId)
    // formData.append('team_type', teamData.team_type)
    // formData.append('team_name', teamName)
    // formData.append('nonce', group_dashboard.nonce_team_settings)
    try {
      // const request = await performRequest(group_dashboard.ajaxurl, formData)
      // const res = await request.json()
      const res = await Tangible?.ajax('msync_update_team_name', {
        team_id: teamId,
        team_type: teamData.team_type,
        team_name: teamName
      })
      if (!res.success) {
        throw new Error( res.errors.shift() )
      }
      setNameResponse('')
      refetchTeamData()
      return res.success
    } catch (error) {
      console.error( error )
      setNameResponse({
        type: 'error',
        message: error.toString()
      })
      return false
    }
  }

  useEffect(() => {
    ( ! teamName || teamName === teamData.team_name )
    ? setIsDisable( true )
    : setIsDisable( false )
  }, [teamName])

  return (
    <>
      { teamData.is_user_team_owner && filtersData.home.owner_can_rename_organization && (
        <Card title={`${filtersData.woo.teams.singular_label} Settings`}>
          <div className='msync-card__body'>
            { nameResponse && ! isLoading && ! isFetching && <ResponseMessage response={ nameResponse } /> }
            <div className='msync-form msync-flex msync-flex--wrap'>
              <div className='msync-form__group'>
                <label htmlFor='msyncOrgName' className="msync-visually-hidden">{`${filtersData.woo.teams.singular_label} name`}</label>
                <input type='text' 
                  id="msyncOrgName"
                  placeholder={`${filtersData.woo.teams.singular_label} name`}
                  className='msync-input' 
                  value={ teamName }
                  onChange={ (e) => setTeamName( e.target.value ) } 
                />
              </div>
              <Button
                name={ isLoading || isFetching ? 'Updating...' : 'Update name' }
                onClick={ () => refetch() }
                disabled={ isDisable || isLoading || isFetching ? true : false }
                />
            </div>
          </div>
        </Card> 
      )}
      <TeamSeats teamData={ teamData } teamOptionsData={ teamOptionsData } />
      { addSeatVisibility( teamData ) && (
          <AddTeamSeats 
            from='team-settings' 
            teamData={ teamData } 
            refetchTeamData={ refetchTeamData } 
            teamOptionsData={ teamOptionsData } 
          />
      )}
      {/* <RestrictDomains/> */}
    </>
  )
}

export default TeamSettings
